import Image from 'next/future/image'
import { useTranslation } from 'next-i18next'
import PluginTooltip from './PluginTooltip'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import PluginAddToCartDemo from './PluginAddToCartDemo'
import PluginAddToCartLicenses from './PluginAddToCartLicenses'
import Link from 'next/link'
import ShareButtons from '../ShareButtons'
import TotalRating from '../TotalRating'

export default function PluginAddToCart ({ plugin, language }) {
  const { t } = useTranslation(['plugins', 'categories', 'applications'])
  const applicationLoaded = useSelector(state => state.app.hasLoaded)

  const currentDescription = useMemo(() => {
    const description = plugin?.descriptions?.find(description => description.language === language)

    if (description && (description.intro || description.description)) {
      return description
    }

    return plugin?.descriptions[0]
  })

  useEffect(() => {
    if (!applicationLoaded) return

    const tooltips = [...document.querySelectorAll('[data-bs-toggle="tooltip"]')]
    tooltips.map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl))
  }, [applicationLoaded])

  return (
    <div className="container appendix appendix--bottomright appendix--dark bg-light-blue py-5 px-4 p-md-5">
      <div className="text-end">
        <ShareButtons />
      </div>
      <div className="row justify-content-between align-items-center">
        <div className="col-12 col-lg-6">
          <div className="d-flex gap-2 flex-wrap">
            {
              plugin.categories.map(category => (
                <span
                  key={category.id}
                  className="rounded-pill badge bg-primary text-light fs-6"
                >
                  {t(category.category, { ns: 'categories' })}
                </span>
              ))
            }
          </div>
          <h1 className="text-dark-blue mt-2 fs-2">
            <strong>{plugin.name}</strong>
          </h1>
          <span className="d-block mb-2">
            <span className="d-flex align-items-center">
              <TotalRating
                canRate={false}
                rating={plugin.rating_total}
                onRatingChange={() => {}}
              />
              <span className="ms-2">{plugin.rating_count}</span>
            </span>
          </span>
          <p>
            {currentDescription && currentDescription.intro}
          </p>
          <PluginTooltip compatibilities={plugin.compatibilities || []} />
          {
            plugin.is_free && (
              <span>
                <span className="d-block">
                  <span className="fs-1 text-dark-blue me-2 mb-2 d-inline-block">
                    <strong>
                      {t('detail.cart.free')}*
                    </strong>
                  </span>
                  <span className="fs-6">* {t('detail.cart.free_product')}</span>
                </span>
              </span>
            )
          }
          {
            !plugin.is_free && (
              <>
                <hr className="my-3 my-md-5" />
                <PluginAddToCartLicenses plugin={plugin} />
              </>
            )
          }
          <div className="row mt-3 align-items-center">
            {
              (plugin.is_free && (!plugin.demo_url || !plugin.company || !plugin.company?.company_constraints.has_download)) && (
                <div className="col-12">
                  <Link href={`/seller/${plugin.company.slug}`}>
                    <a
                      className="btn btn-primary w-100 mb-3"
                      target="_blank"
                    >
                      {t('detail.cart.to_seller')}
                    </a>
                  </Link>
                </div>
              )
            }
            {
              (plugin.demos.length > 0 && plugin.company && plugin.company?.company_constraints.has_download === true) && (
                <PluginAddToCartDemo plugin={plugin} />
              )
            }
          </div>
        </div>
        <div className="col-12 col-lg-5 text-end d-none d-lg-block">
          <Image alt=""
            src={plugin.logo.url}
            width={plugin.logo.width}
            height={plugin.logo.height}
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  )
}
